import AbstractVendor from '@/business-components/sale/callcenter/AbstractVendor';
import _ from 'lodash';
import modal from '@/utils/modal';
import beacon from '@/common/report-beacon';
import events from '@/common/beacon-events';
import message from '@/utils/message';

const TCCCDialDirectionMap = {
  2: 'DIAL_DIRECTION_IN', // 呼入
  1: 'DIAL_DIRECTION_OUT', // 呼出
};

const CALL_DIRECTION = {
  'DIAL_DIRECTION_IN': 2, // 呼入
  'DIAL_DIRECTION_OUT': 1, // 呼出
};

const TcccTraceMap = {
  CALLING_STATUS_OUT_AGENT_ALTER: {
    CallStatus: 2,
    CallDirection: 1,
  }, // "外呼坐席振铃事件"
  CALLING_STATUS_OUT_CUSTOMER_CONNECT: {
    CallStatus: 3,
    CallDirection: 1,
  }, // "外呼坐席接通事件"
  CALLING_STATUS_AGENT_DISCONNECT: {
    CallStatus: 4,
    CallDirection: 1,
  }, // "坐席挂断事件"
  CALLING_STATUS_CUSTOMER_DISCONNECT: {
    CallStatus: 4,
    CallDirection: 2,
  }, // "客户挂断事件"
};

const TCCC_TRACE_MAP = {
  CONNECT: 'connect', // 前端自定义状态，拨打电话后马上切换到这个状态
  CALLING: 'calling', // 来电
  ONLINE: 'online', // 已接通
  OVER: 'over', // 通话结束
};

const defaultCallerNumber = null;

class TcccSoft extends AbstractVendor {
  constructor(agent, info = {}) {
    super();
    this.name = 'CALL_CENTER_VENDOR_TCCC';
    this.agent = agent;
    this.dialStatus = {};
    this.currentDisplayNumber = '';
    this.currentSessionId = '';
    this.callInSetParams = this._callInSetParams.bind(this);
    this.limitQuickClickCall = false;
  }

  bind({ agencyId, userId, callCenter }) {
    this.agencyId = agencyId;
    this.userId = userId;
  }

  getLimitQuickClickCall() {
    return this.limitQuickClickCall;
  }

  setLimitQuickClickCall(flag) {
    this.limitQuickClickCall = flag;
  }

  onDialOut(callback) {
    this.dialOutCallback = callback;
  }

  onUpdateStatus(callback) {
    this.onUpdateStatusCallback = callback;
  }

  onDialStatusUpdate(callback) {
    this.onDailStatusUpdateCallback = callback;
  }

  onDialIn(callback) {
    this._onDialIn = callback;
  }

  renderErrModal = (err = {}) => {
    return <div className="call-err-modal">
      <p className="err-msg">{err.msg}</p>
      <br />
      <p>code: {err.code}</p>
      <p>errcode: {err.status}</p>
      <p>errmsg: {err.errorMsg}</p>
    </div>;
  }
  _callInSetParams(params) {
    this.dialStatus.params = Object.assign({}, params);
  }
  // 手动拨打号码
  makeCall(number, extraParams, extraResp, params = {}) {
    this.dialStatus.number = number;
    this.dialStatus.params = Object.assign({}, params, extraParams);
    this.dialStatus.resp = extraResp || {};
    const _this = this;
    return new Promise((resolve, reject) => {
      const callOptions = {
        phoneNumber: number,
      };
      if(this.currentDisplayNumber) {
        callOptions.callerPhoneNumber = this.currentDisplayNumber;
      }
      window.tccc.Call.startOutboundCall(callOptions).then((res) => {
        if (res.status === 'success') {
          resolve(res);
        } else {
          reject(res);
        }
      }, (err) => {
        this.limitQuickClickCall = false;
        beacon.onUserAction(events.callCenter.key, {
          status: 'fail',
          code: err.status,
          message: err.errorMsg,
          mode: _this.mode,
          appId: _this.appId,
        });
        console.log(err, '呼叫失败');
        const errMsg = this.renderErrModal(err);
        modal.error(errMsg);
      });
    // }
    });
  };

  report(res, callInfo, tcccRes) {
    _.forEach(TcccTraceMap, (value, key) => {
      if (_.isEqual(value, { CallStatus: callInfo.CallStatus, CallDirection: callInfo.CallDirection })) {
        this.dialStatus.sessionId = res.sessionId;
        this.dialStatus.dialDirection = TCCCDialDirectionMap[callInfo.CallDirection];
        this.dialStatus.callingStatus = key;
        console.log('2、查看 this.dialStatus', this.dialStatus);
        this.onDailStatusUpdateCallback({ ...this.dialStatus }, tcccRes);
      }
    });
  }

  updateDisplayNumber(number) {
    this.currentDisplayNumber = number;
  }
  hungUp() {
    this.agent.Call.hungUp({
      sessionId: this.currentSessionId,
    });
  }
  addReportEvent() {
    const cacheTcccRes = {};
    this.agent.on('callIn', (res) => {
      this.currentSessionId = res.sessionId;
      cacheTcccRes[res.sessionId] = res;
      console.log('呼入啦', res);
    });

    this.agent.on('callOuted', (res) => {
      console.log('拨打电话啦', res);
      cacheTcccRes[res.sessionId] = res;
      this.currentSessionId = res.sessionId;
      // 拨打电话的api调用成功的事件监听
      this.report(res, {
        CallStatus: 2,
        CallDirection: CALL_DIRECTION.DIAL_DIRECTION_OUT,
      }, res);
    });

    this.agent.on('calloutAccepted', (res) => {
      document.getElementById('myAudio').play();
      this.limitQuickClickCall = false;
      console.log('电话接通啦', res, { ...cacheTcccRes[res.sessionId] });
      this.currentSessionId = res.sessionId;
      // 开始接通电话的事件监听
      this.report(res, {
        CallStatus: 3,
        CallDirection: CALL_DIRECTION.DIAL_DIRECTION_OUT,
      }, { ...cacheTcccRes[res.sessionId] });
    });


    this.agent.on('sessionEnded', (res) => {
      // 电话结束的事件监听 closeBy 来区分坐席还是用户挂断
      console.log('电话结束啦', res);
      this.limitQuickClickCall = false;

      if(['seat', 'user'].includes(res.closeBy)) {
        console.log('1、呼入准备调用trace-call', {
          CallStatus: 4,
          // tccc 1表示呼出，0 表示呼入
          CallDirection: res.direction === '1' ? 1 : 2,
        });
        this.report(res, {
          CallStatus: 4,
          // tccc 1表示呼出，0 表示呼入
          CallDirection: res.direction === '1' ? 1 : 2,
        }, res);
        cacheTcccRes[res.sessionId] = {};
      }
    });
  }

  // 通过线索详情页，已有号码拨打
  dialOut(number, params) {
    const _this = this;
    const makeCall = (number, extraParams, extraResp) => {
      this.dialStatus.number = number;
      this.dialStatus.params = Object.assign({}, params, extraParams);
      this.dialStatus.resp = extraResp || {};
      return new Promise((resolve, reject) => {
        const callOptions = {
          phoneNumber: number,
        };
        if(this.currentDisplayNumber) {
          callOptions.callerPhoneNumber = this.currentDisplayNumber;
        }
        _this.agent.Call.startOutboundCall(callOptions).then((res) => {
          if (res.status === 'success') {
            resolve(res);
          } else {
            reject(res);
          }
        }, (err) => {
          this.limitQuickClickCall = false;
          beacon.onUserAction(events.callCenter.key, {
            status: 'fail',
            code: err.status,
            message: err.errorMsg,
            mode: _this.mode,
          });
          console.log(err, '呼叫失败');
          const errMsg = this.renderErrModal(err);
          modal.error(errMsg);
        });
      });
    };

    let precheckParam = {
      mode: 'program', // 程序触发
      isIntellectCall: false,
      calleeNumber: number,
      makeCall,
      callerNumber: defaultCallerNumber,
      ...params,
    };
    // 回调 CallCenter，由其判断是否需要继续呼叫
    const precheck = this.dialOutCallback ? this.dialOutCallback(precheckParam) : Promise.resolve();

    return precheck;
  }

  dialIn() {
    // this.agent.answer({
    //   success(res) {
    //     console.log('.....接听');
    //   },
    //   fail: (err) => {
    //     console.log(err, '.....接听失败');
    //     modal.error(`${err?.msg}, 错误code: ${err?.code}`);
    //   },
    // });
  }
}

export default TcccSoft;
